import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router';
import { PageSkeleton } from '../../components/Page';

const DashboardPage = lazy(() => import('./DashboardPage'));

/** Rotas desta área (dentro do shell autenticado). */
export const routes: RouteObject[] = [
  {
    path: 'inicio',
    element: (
      <Suspense fallback={<PageSkeleton variant="dashboard" />}>
        <DashboardPage />
      </Suspense>
    ),
  },
];

/** Rotas protegidas sem o shell (ex.: impressão). */
export const fullscreenRoutes: RouteObject[] = [];
